<template>
	<div class="navigation-layout">
		<div class="content" :style="{
			gridTemplateRows: $store.getters.checkedIn.job ? '1fr 70px' : '1fr'
		}">
			<router-view class="page" />
			<div v-if="_checkedIn.length > 0" class="check-in" @click="checkedInJobClick">
				<div class="status" :style="{  }"></div>
				<div class="title">Du er checket ind på {{ _checkedIn.length }} {{ _checkedIn.length == 1 ? 'opgave' : 'opgaver' }}</div>
			</div>
		</div>
		<div :class="{
			navigation: true,
			active: $store.getters.navigation.active
		}" @click.stop="function () { $store.commit('navigation', { active: false }) }">
			<div>
				<div class="title">Menu</div>
				<tab-view :tabs="_tabs" v-model="tab" />
				<div class="version">v1.30</div>
			</div>
		</div>
	</div>
</template>

<script>
	import SelectPopupView from '@/components/SelectPopupView'

	export default {
		components: {
			
		},
		data() {
			return {
				tab: '',
			};
		},
		computed: { 
			_tabs() {
				return [
					{
						name: 'calendar',
						label: 'Kalender'
					},
					{
						name: 'news',
						label: 'Nyheder',
						badge: this.$store.getters.unreadNews.length
					},
					{
						name: 'leave',
						label: 'Fravær'
					},
					{
						name: 'hours',
						label: 'Timer'
					},
					{
						name: 'contacts',
						label: 'Kontakter'
					}
				];
			},
			_checkedIn() {
				var r = [];

				for (var i = 0; i < this.$store.getters.stamps.length; ++i) {
					var stamp = this.$store.getters.stamps[i];

					if (stamp.task_id !== null) {
						r.push(stamp);
					}
				}

				return r;
			}
		},
		watch: {
			tab(newVal) {
				if (newVal !== this.$route.name) {
					this.$router.push({
						name: newVal
					});

					this.$store.commit('navigation', {
						active: false
					});
				}
			}
		},
		mounted() {
			this.tab = this.$route.name;
		},
		methods: {
			check(taskId, type, callback) {
				var self = this;

				callback();

				self.axios.post('/me/stamps/', {
					lat: 0,
					lng: 0,
					type: type,
					task_id: taskId
				}).then(function (r) {
					self.axios.get('/me/stamps/active/').then(function (r) {
						console.log(r.data);
						
						self.$store.commit('stamps', r.data);
					});
				});

				/*
				function success(position) {
					const lat  = position.coords.latitude;
					const lng = position.coords.longitude;

					callback();

					self.axios.post('/me/stamps/', {
						lat: lat,
						lng: lng,
						type: type,
						task_id: taskId
					}).then(function (r) {
						self.axios.get('/me/stamps/active/').then(function (r) {
							console.log(r.data);
							
							self.$store.commit('stamps', r.data);
						});
					});
				}

				function error() {
					//self.gps = 'Unable to retrieve your location';
					//window.location = 'alert:Kunne ikke checke ind, mangler lokation.';
					alert('Kunne ikke checke ind, mangler lokation.');
				}

				if (!navigator.geolocation) {
					//self.gps = 'Geolocation is not supported by your browser';
				} else {
					//self.gps = 'Locating…';
					navigator.geolocation.getCurrentPosition(success, error);
				}
					*/
			},
			checkedInJobClick() {
				var self = this;

				var options = [];

				for (var i = 0; i < this._checkedIn.length; ++i) {
					var ci = this._checkedIn[i];

					options.push({
						label: ci.task.name,
						callback() {
							self.$store.commit('pushPopup', {
								component: SelectPopupView,
								props: {
									title: ci.task.name,
									options: [
										{
											label: 'Check ud',
											callback() {
												//self.$store.commit('jobCheckOut');
												self.check(ci.task_id, 'out', function () {
													self.$store.commit('clearPopup');
												});
											}
										}
									],
									actions: [
										{
											label: 'Annuller',
											callback() {
												self.$store.commit('popPopup');
											}
										}
									]
								}
							});
						}
					});
				}

				self.$store.commit('pushPopup', {
					component: SelectPopupView,
					props: {
						title: 'Vælg opgave',
						options: options,
						actions: [
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('popPopup');
								}
							}
						]
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.navigation-layout {
		width: 100%;
		height: 100%;

		& > .content {
			display: grid;
			grid-template-columns: 1fr;
			width: 100%;
			height: 100%;

			& > div {
				min-height: 0;
			}

			& > .check-in {
				position: relative;
				background-color: #15161A;

				& > .status {
					position: absolute;
					left: 0;
					top: 10px;
					width: 6px;
					bottom: 10px;
				}

				& > .title {
					font-size: 16px;
					color: white;
					line-height: 50px;
					padding: 0 0 0 20px;
				}
			}

			&.active {
				grid-template-rows: 1fr 50px;
			}
		}

		& > .navigation {
			padding-top: 10px;
			position: fixed;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			transition: opacity 100ms ease-in, visibility 0s ease-in 100ms;
			opacity: 0;
			background-color: rgba(21, 22, 26, 0.5);

			
			visibility: hidden;

			& > div {
				padding-top: 20px;
				position: absolute;
				left: 0;
				top: 0;
				height: 100%;
				width: 200px;
				background-color: #15161A;
				border: none;
				transition: transform 100ms ease-in;
				
				transform: translateX(-100px);

				-webkit-box-shadow: 0px 0px 15px 1px rgba(0,0,0,0.57); 
				box-shadow: 0px 0px 15px 1px rgba(0,0,0,0.57);

				& > .title {
					font-size: 14px;
					padding-left: 20px;
					margin-bottom: 10px;
					color: white;
				}

				& > .version {
					color: white;
					position: absolute;
					left: 20px;
					bottom: 20px;
					font-size: 12px;
				}
			}

			&.active {
				opacity: 1;
				visibility: visible;
				transition: opacity 100ms ease-out, visibility 0s ease-out;

				& > div {
					transition: transform 100ms ease-out;
					transform: translateX(0px);
				}
			}
		}
	}
</style>